<template lang="pug">
  .store
    v-layout.my-6(v-if="!tenant")
      v-row.fill-height.ma-0(align='center' justify='center')
        v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
    .content(v-else)
      .background-header.white
        v-container.white(style="max-width:600px")
          v-layout.mt-2
            v-avatar.ml-2.mr-4(size="100px")
              v-img(:src="tenant.cover_image ? tenant.cover_image.file : require('@/assets/image_placeholder.png')")
            v-col.pa-0
              .h6.basic800--text.mb-2 {{ tenant.name || company.name }}
              a.p1.info500--text(:href="getShareLinkURL()" target="_blank" style="text-decoration: none") {{ getShareLinkURL() }}
              v-layout.my-2.mt-4
                v-btn.button-AA-small(color="textColorAccent" outlined x-small height="32" width="96" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}" @click="openEditYezzaMall =! openEditYezzaMall") Edit
                v-btn.button-AA-small.ml-4(color="textColorAccent" outlined x-small height="32" width="96" :style="{'background-color': $vuetify.theme.themes[$theme].textColorAccent}" @click="shareSheet =! shareSheet")
                  div.basic100--text Share

      v-container(style="max-width:600px")
        .s1.primary400--text.mx-3 Store settings
        v-card.my-3.mt-2(flat :outlined="$vuetify.breakpoint.smAndDown ? false : true")
          v-layout(@click="openManageProductCategory = true" style="cursor: pointer")
            v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
              eva-icon.ma-auto(name="clock-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
            v-layout.py-4
              div.my-auto
                .s1.basic800--text Business Hours
                .c1.basic600--text Set your business hours
          v-divider.basic300
          v-layout(@click="openYezzaStoreDialog = true" style="cursor: pointer")
            v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
              eva-icon.ma-auto(name="clipboard-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
            v-layout.py-4
              div.my-auto
                .s1.basic800--text WhatsApp Form
                .c1.basic600--text Collect data from your customer

      .modals
        edit-yezza-mall(v-if="openEditYezzaMall" :open.sync="openEditYezzaMall" :tenant.sync="tenant" :settings="settings")
        tenant-business-hours(v-if="openManageProductCategory" :open.sync="openManageProductCategory" :settings="settings" :company="company")
        add-wa-form(v-if="openYezzaStoreDialog" :open.sync="openYezzaStoreDialog" :company="company" :form.sync="tenant.form")
        y-bottom-sheet(v-model='shareSheet' inset)
          v-list
            v-subheader Share url by ( {{ getShareLinkURL() }} )
            v-list-item(@click="shareUrlToSocial('whatsapp')")
              v-list-item-avatar
                v-icon(color="green") fab fa-whatsapp
              v-list-item-title WhatsApp
            v-list-item(@click="shareUrlToSocial('facebook')")
              v-list-item-avatar
                v-icon(color="#3b5998") fab fa-facebook
              v-list-item-title Facebook
            v-list-item(@click="copyUrl" v-clipboard:copy="getShareLinkURL()")
              v-list-item-avatar
                v-icon mdi-content-copy
              v-list-item-title Copy Store Link

</template>

<script>
import { mapState, mapActions } from 'vuex'
import EditYezzaMall from '@/components/dialogs/EditYezzaMall.vue'
import TenantBusinessHours from '@/components/dialogs/TenantBusinessHours.vue'
import ProductCategoryItem from '@/components/ProductCategoryItem.vue'
import AddWaForm from '@/components/dialogs/AddWaForm.vue'
export default {
  name: 'Coupons',
  components: { EditYezzaMall, TenantBusinessHours, ProductCategoryItem, AddWaForm },
  props: ['company'],
  data: () => ({
    settings: null,
    tenant: null,
    openEditYezzaMall: false,
    openManageProductCategory: false,
    openYezzaStoreDialog: false,
    shareSheet: false
  }),
  computed: {
    ...mapState('user', ['member'])
  },
  mounted () {
    this.fetchSettings()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchSettings() {
      this.$axios.get(`malls/lookup_company?company=${this.company.slug}`)
        .then((response) => {
          this.settings = response.data
          this.$axios.get(`/malls/${response.data.mall.id}/branches/${response.data.branch.id}/tenants/${this.company.slug}/?expand=form,categories`)
            .then((resp) => {
              this.tenant = resp.data
            }).catch(() => {})
        })
    },
    copyUrl() {
      this.showMessage(['success', this.$t('success_message.link_copied_to_clipboard')])
      this.shareSheet = false
    },
    getShareLinkURL () {
      return `https://${this.settings.mall.slug}/${this.settings.branch.slug}/${this.company.slug}`
    },
    shareUrlToSocial(platform) {
      if (platform == 'whatsapp') {
        window.open(`https://api.whatsapp.com/send?text=${this.getShareLinkURL()}`, '_blank')
      } else if (platform == 'facebook') {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${this.getShareLinkURL()}`, '_blank')
      } else if (platform === 'twitter' ) {
        window.open(`http://twitter.com/share?url=${encodeURIComponent(this.getShareLinkURL())}`, '_blank')
      }
    },
  }
}
</script>
